import { useEffect } from 'react';
import { Platform } from 'react-native';
import { UnistylesRuntime, useStyles } from 'react-native-unistyles';

import { useCurrentOrganization } from '@/core/organization';

// Swaps the browser tab favicon to the white-label organization's favicon
// (theme-aware), falling back to the static favicon from app.config when there
// is no organization or no configured favicon. Web only.
export function useOrganizationFavicon() {
  // Subscribe to theme changes so the effect re-runs on light/dark toggle.
  const { theme } = useStyles();
  const { organization } = useCurrentOrganization();

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const favicon =
      UnistylesRuntime.themeName === 'dark'
        ? organization?.darkFavicon
        : organization?.lightFavicon;

    if (!favicon) return;

    // Browsers cache the favicon aggressively and often ignore an href change
    // on an existing <link>. Removing the old icon link(s) and appending a
    // fresh node forces the tab favicon to actually re-read.
    document
      .querySelectorAll<HTMLLinkElement>("link[rel~='icon']")
      .forEach((node) => node.parentNode?.removeChild(node));

    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = favicon;
    document.head.appendChild(link);
  }, [organization, theme]);
}
